export default class ArticleTwoColumn {
  constructor(component) {
    this.refs = {
      link: '.js-link',
      container: '.js-linkContainer',
    }
    this.dom = {
      $component: component,
      $container: component.querySelector(this.refs.container),
    }
    this.state = {}

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this
    if (dom.$container) {
      dom.$container.addEventListener('click', this.urlRedirect.bind(this))
    }
  }

  urlRedirect() {
    const { dom } = this
    const link = dom.$component.querySelector(this.refs.link).href
    window.location.href = link
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.FeaturedArticles = this
  }
}
